// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Infrastructure
import { IntegrationsAPI } from "views/Integrations/infrastructure";
// Vendor
import { showNotify } from "vendor/application/disptach";
import { getSuncoConfig } from "vendor/application";
// Components
import { Button, SelectSimple } from "@components/Input";
import { ElementsCustom } from "@components/Elements";
import DialogAction from "components/Modals/Dialog/DialogAction";
import AccordionProject from "views/Integrations/application/edit/Sunco/accordion_project";
// Assets
import { arrowRightSvg, closeSvg } from "@assets";
// Styles
import "views/Integrations/styles/styles.scss";
// Material
import { CircularProgress, Divider } from "@material-ui/core";
// SVG
import { channelsSvg } from "assets";

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      integration: "",
      projects: {
        active: [],
        all: [],
        selectable: []
      },
      app_integrations: [],
      open: false,
      loading_switchboard: false,
      loading_campaigns: false,
      loading_integration: true
    };
  }

  componentDidMount() {
    this.getIntegration();
  }

  getIntegration = async () => {
    const { access, user, projects } = this.props.data;
    try {
      const obj = new IntegrationsAPI(
        user.account_id,
        access,
        this.props,
        user
      );
      let res = await obj.get_channel(this.props.match.params.id);

      if (res.info.app.key_id && res.info.app.key_secret) {
        this.getAppIntegrations();
      }

      var projects_selectable = [];

      projects.active.forEach((project) => {
        var config_exist = res.info.projects.configs.filter(
          (config) => config.project_id === project.id
        )[0];
        if (!config_exist) {
          projects_selectable.push(project);
        }
      });

      this.setState({
        integration: res,
        projects: {
          active: projects.active,
          selectable: projects_selectable,
          all: projects.all
        },
        loading_integration: false
      });
    } catch (e) {
      this.return();
    }
  };

  getAppIntegrations = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new IntegrationsAPI(
        user.account_id,
        access,
        this.props,
        user
      );
      let res = await obj.get_app_integrations(this.props.match.params.id);

      this.setState({ app_integrations: res });
    } catch (e) {}
  };

  putIntegration = async (e, type) => {
    e.preventDefault();
    const { access, user } = this.props.data;
    const { integration } = this.state;

    if (this.handleKeyValidation()) {
      try {
        const obj = new IntegrationsAPI(
          user.account_id,
          access,
          this.props,
          integration
        );
        await obj.put_integration(this.props.match.params.id);

        switch (type) {
          case "switchboard":
            this.putSwitchBoard();
            break;
          default:
            this.props.dispatch(
              showNotify({
                from: "integrations",
                type: "edit",
                severity: "success"
              })
            );
            this.setState({ loading_integration: false });
            break;
        }
      } catch (err) {
        this.props.dispatch(showNotify({ message: err, severity: "error" }));
        this.setState({
          loading_integration: false,
          loading_switchboard: false,
          loading_campaigns: false
        });
      }
    } else {
      this.setState({
        loading_integration: false,
        loading_switchboard: false,
        loading_campaigns: false
      });
      this.props.dispatch(
        showNotify({ message: "integration_sunco_api", severity: "error" })
      );
    }
  };

  putSwitchBoard = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new IntegrationsAPI(
        user.account_id,
        access,
        this.props,
        null
      );
      const res = await obj.put_switchboard(this.props.match.params.id);

      this.props.dispatch(
        showNotify({
          from: "integrations",
          type: "switchboard",
          severity: "success"
        })
      );

      this.getAppIntegrations();

      this.setState({ integration: res, loading_switchboard: false });
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
      this.setState({ loading_switchboard: false });
    }
  };

  deleteIntegration = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new IntegrationsAPI(user.account_id, access, this.props);
      await obj.delete_integration(this.props.match.params.id);

      this.props.dispatch(
        showNotify({
          from: "integrations",
          type: "delete",
          severity: "success"
        })
      );

      this.setState({ open: false });
      this.return();
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  handleKeyValidation = () => {
    const { integration } = this.state;
    return !!(integration.info.app.key_id && integration.info.app.key_secret);
  };

  updateElement = (e, domain, type) => {
    const { integration } = this.state;
    integration.info[domain][type] = e.target.value;
    this.setState({ integration: integration });
  };

  updateElementCustomFields = (e, type) => {
    const { integration } = this.state;
    if (type === "use_custom_fields") {
      integration.info.zendesk[type] = !integration.info.zendesk[type];
    } else {
      integration.info.zendesk[type] = e.target.value;
    }
    this.setState({ integration: integration });
  };

  updateProjectElement = (e, domain, type, i) => {
    const { integration } = this.state;
    if (type === "tags" || type === "artifact") {
      integration.info.projects.configs[i] = e;
    } else if (type === "historical_messages_number") {
      integration.info.projects.configs[i][domain][type] = e ? parseInt(e) : 0;
    } else {
      integration.info.projects.configs[i][domain][type] = e;
    }
    this.setState({ integration: JSON.parse(JSON.stringify(integration)) });
  };

  deleteProjectElement = (e, i) => {
    const { integration, projects } = this.state;
    integration.info.projects.configs.splice(i, 1);

    var projects_selectable = [];

    projects.all.forEach((project) => {
      var config_exist = integration.info.projects.configs.filter(
        (config) => config.project_id === project.id
      )[0];
      if (!config_exist && project.active && !project.sandbox_id) {
        projects_selectable.push(project);
      }
    });

    projects.selectable = projects_selectable;

    this.setState({
      integration: JSON.parse(JSON.stringify(integration)),
      projects: projects
    });
  };

  updateAppIntegration = (e, type, i) => {
    const { app_integrations, integration, projects } = this.state;
    var integrations = integration.info.projects.integrations,
      configs = integration.info.projects.configs,
      exist_integration = integrations.filter(
        (itg) => itg.integration_id === app_integrations[i].id
      )[0],
      exist_project = configs.filter((config) => config.project_id === e)[0];

    if (type === "delete") {
      integration.info.projects.integrations = integrations.filter(
        (int) => int.integration_id !== app_integrations[i].id
      );
    } else if (!exist_integration) {
      integrations.push({
        integration_id: app_integrations[i].id,
        project_id: e
      });
    } else {
      exist_integration.project_id = e;
    }

    if (type !== "delete" && !exist_project) {
      configs.push(getSuncoConfig(e));
      projects.selectable = projects.selectable.filter((project) => {
        return project.id !== e;
      });
    }

    this.setState({ integration: integration });
  };

  getAppIntegrationName = (app_integration) => {
    const { integration, projects } = this.state,
      integrations = integration.info.projects.integrations;

    var exist_integration = integrations.filter(
      (itg) => itg.integration_id === app_integration.id
    )[0];
    if (exist_integration) {
      var project = projects.all.filter(
        (pr) => pr.id === exist_integration.project_id
      )[0];
      return project.name;
    }
    return false;
  };

  selectDefaultProject = (e, type) => {
    const { integration, projects } = this.state,
      configs = integration.info.projects.configs,
      project_id = e?.id;
    var exist_integration = configs.filter(
      (config) => config?.project_id === project_id
    )[0];
    if (!exist_integration) {
      configs.push(getSuncoConfig(project_id));

      projects.selectable = projects.selectable.filter((project) => {
        return project.id !== project_id;
      });
    }
    if (type !== "add_project") {
      integration.info.projects.default = project_id;
    }

    this.setState({ integration: integration });
  };

  getProjectName = (project_id) => {
    const { projects } = this.state;
    return projects.all.filter((project) => project.id === project_id)[0]?.name;
  };

  return = () => {
    const { history } = this.props;
    history.push("/integrations");
  };

  isAppIntegrationInUse = (config) => {
    const { integration } = this.state,
      integrations = integration.info.projects.integrations,
      project_id = config.project_id;

    return integrations.filter((int) => int.project_id === project_id).length;
  };

  render() {
    const {
      integration,
      app_integrations,
      projects,
      open,
      loading_switchboard
    } = this.state;
    const { t } = this.props;
    const { isSending } = this.props.data;
    return (
      <React.Fragment>
        <div className={"cen_integrations"}>
          <div className={"header"}>
            <div className={"header_content"}>
              <div onClick={() => this.return()} className={"header_action"}>
                {arrowRightSvg()}
              </div>
              <div className={"header_image"}>{channelsSvg("sunco")}</div>
              <div className={"header_title"}>
                <span className={"title"}>
                  {t("integrations:channels.sunco.title")}
                </span>
                <span className={"description"}>
                  {t("integrations:categories.customer")}
                </span>
              </div>
            </div>
            <div className={"header_actions"}>
              {isSending ? (
                <Button
                  type={"primary"}
                  disabled
                  text={<CircularProgress size={21} />}
                />
              ) : (
                <Button
                  type={"primary"}
                  text={t("integrations:save.action_button")}
                  onClick={(e) => this.putIntegration(e)}
                />
              )}
            </div>
          </div>
          {integration ? (
            <div className={"integration"}>
              {/* APP ID */}
              <ElementsCustom
                t={t}
                type={"sunco"}
                input_type={"string"}
                element_type={"app_id"}
                element={integration.info.app.id}
              />
              <Divider />
              {/* API KEY */}
              <div
                className={
                  "cen_channels_integration_element cen_channels_integration_apiKey"
                }
              >
                <div className={"cen_channels_integration_apiKey_header"}>
                  <span className={"title"}>
                    {t("channels:sunco.integrate.api_key.title")}
                  </span>
                  <span className={"subtitle"}>
                    {t("channels:sunco.integrate.api_key.description")}
                  </span>
                </div>
                {/* AP KEY INFO */}
                <div className={"cen_channels_integration_apiKey_content"}>
                  {/* API KEY ID*/}
                  <ElementsCustom
                    t={t}
                    type={"sunco"}
                    input_type={"input"}
                    element_type={"api_key_id"}
                    element={integration.info.app.key_id}
                    updateElement={(e) =>
                      this.updateElement(e, "app", "key_id")
                    }
                  />
                  <Divider />
                  {/* API KEY SECRET */}
                  <ElementsCustom
                    t={t}
                    type={"sunco"}
                    input_type={"input"}
                    element_type={"api_key_secret"}
                    element={integration.info.app.key_secret}
                    updateElement={(e) =>
                      this.updateElement(e, "app", "key_secret")
                    }
                  />
                  <Divider />
                  {/* SWITCHBOARD */}
                  <ElementsCustom
                    t={t}
                    type={"sunco"}
                    input_type={"button"}
                    element_type={"switchboard"}
                    element={integration.info.switchboard.updated}
                    disabled={
                      !integration.info.app.key_secret ||
                      !integration.info.app.key_id ||
                      integration.info.switchboard.updated
                    }
                    loading={loading_switchboard}
                    updateElement={(e) => {
                      this.setState({ loading_switchboard: true });
                      this.putIntegration(e, "switchboard");
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={"content"}>
              <div className="loading">
                <CircularProgress color="primary" size={50} />
              </div>
            </div>
          )}
        </div>
        {integration && (
          <React.Fragment>
            {app_integrations.length > 0 && (
              <div className={"cen_integrations"}>
                <div className={"header"}>
                  <div className={"header_content"}>
                    <div className={"header_title"}>
                      <span className={"title"}>
                        {t("channels:sunco.integrate.integrations.title")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={"integration"}>
                  <div
                    className={"cen_channels_integration_integrations_content"}
                  >
                    {app_integrations.map((app_integration, i) => {
                      return (
                        <div className={"app_integration"} key={i}>
                          <div className={"app_integration_header"}>
                            <span>{app_integration.display_name}</span>
                            <span>{app_integration.type}</span>
                          </div>
                          <div className={"app_integration_selector"}>
                            <SelectSimple
                              valueSelected={this.getAppIntegrationName(
                                app_integration
                              )}
                              items={projects.active}
                              onSelect={this.updateAppIntegration}
                              placeholder={t(
                                "channels:sunco.integrate.integrations.placeholder"
                              )}
                              type={"app_integration"}
                              value={"id"}
                              iteration={i}
                              t={t}
                            />
                            {this.getAppIntegrationName(app_integration) && (
                              <div
                                onClick={(e) =>
                                  this.updateAppIntegration(e, "delete", i)
                                }
                                className={"app_integration_selector_close"}
                              >
                                {closeSvg()}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            {/* PROJECTS ZENDESK */}
            <div className={"cen_integrations"}>
              <div className={"header"}>
                <div className={"header_content"}>
                  <div className={"header_title"}>
                    <span className={"title"}>
                      {t("channels:sunco.integrate.config.title")}
                    </span>
                  </div>
                </div>
              </div>
              <div className={"integration"}>
                <div className={"cen_channels_integration_zendesk_content"}>
                  {/* DEFAULT PROJECT */}
                  <ElementsCustom
                    t={t}
                    type={"sunco"}
                    input_type={"select"}
                    element_type={"default_project"}
                    element={this.getProjectName(
                      integration.info.projects.default
                    )}
                    updateElement={this.selectDefaultProject}
                    select_value={"name"}
                    elements={projects.active}
                  />
                  <Divider />
                  {/* ADD PROJECT */}
                  <ElementsCustom
                    t={t}
                    type={"sunco"}
                    input_type={"select"}
                    element_type={"add_project"}
                    element={""}
                    updateElement={this.selectDefaultProject}
                    select_value={"name"}
                    elements={projects.selectable}
                  />
                  {integration.info.projects.configs.map((config, i) => {
                    return (
                      <AccordionProject
                        project_integration_in_use={this.isAppIntegrationInUse(
                          config
                        )}
                        project_default={
                          integration.info.projects.default ===
                          config.project_id
                        }
                        config={config}
                        project_name={this.getProjectName(config.project_id)}
                        updateElement={this.updateProjectElement}
                        deleteElement={this.deleteProjectElement}
                        iteration={i}
                        key={i}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            {/* USE CUSTOM FIELDS */}
            <div className={"cen_integrations"}>
              <div className={"header"}>
                <div className={"header_content"}>
                  <div className={"header_title"}>
                    <span className={"title"}>
                      {t("channels:sunco.integrate.use_custom_fields.title")}
                    </span>
                  </div>
                </div>
              </div>
              <div className={"integration"}>
                {/*ACTIVE*/}
                <ElementsCustom
                  t={t}
                  type={"sunco"}
                  input_type={"switch"}
                  element_type={"use_custom_fields_active"}
                  element={integration.info.zendesk?.use_custom_fields}
                  updateElement={(e) =>
                    this.updateElementCustomFields(e, "use_custom_fields")
                  }
                />
                <Divider />
                {/*SUBDOMAIN*/}
                <ElementsCustom
                  t={t}
                  type={"sunco"}
                  input_type={"input_zendesk"}
                  element_type={"use_custom_fields_subdomain"}
                  element={integration.info.zendesk?.subdomain}
                  updateElement={(e) =>
                    this.updateElementCustomFields(e, "subdomain")
                  }
                />
                <Divider />
                {/*EMAIL*/}
                <ElementsCustom
                  t={t}
                  type={"sunco"}
                  input_type={"input"}
                  element_type={"use_custom_fields_email"}
                  element={integration.info.zendesk?.email}
                  updateElement={(e) =>
                    this.updateElementCustomFields(e, "email")
                  }
                />
                <Divider />
                {/*TOKEN*/}
                <ElementsCustom
                  t={t}
                  type={"sunco"}
                  input_type={"input"}
                  element_type={"use_custom_fields_token"}
                  element={integration.info.zendesk?.token}
                  updateElement={(e) =>
                    this.updateElementCustomFields(e, "token")
                  }
                />
              </div>
            </div>
            {/* DELETE */}
            <div className={"cen_integrations delete"}>
              <div className={"integration"}>
                <div className={"integration_info"}>
                  <span className={"integration_info_title"}>
                    {t("channels:sunco.integrate.delete.title")}
                  </span>
                  <span className={"integration_info_description"}>
                    {t("channels:sunco.integrate.delete.description")}
                  </span>
                </div>
                <Button
                  type={"normal_delete"}
                  text={t("channels:sunco.integrate.delete.action")}
                  onClick={() => this.setState({ open: true })}
                />
              </div>
            </div>
            <DialogAction
              t={t}
              actualLayout={"sunco"}
              handleAction={() => this.deleteIntegration()}
              handleClickOpen={() => this.setState({ open: !open })}
              common
              open={open}
              item={{ name: "", action: "error" }}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_app = connect(mapStateToProps)(Edit);

export default withTranslation(["commons", "channels"])(
  withRouter(connect_app)
);
